module.exports = __webpack_public_path__ + "img/ios-icon-add-app.832a4f30.svg";